import globalTheme from '../../global'

const Dropdown = {
	MuiPopover: {
		styleOverrides: {
			paper: {
				...globalTheme.scrollbarJsx,
				'&.no-bg': {
					backgroundColor: 'transparent',
					'.MuiMenu-list': {
						backgroundColor: globalTheme.palette.background.paper,
					},
				},
			},
		},
	},
}
export default Dropdown
